import { getCachedData } from "./swrCacheProvider"
import type { RecoverResponse } from "./useIP"

/**
 * Gets recovery data from the SWR cache.
 * This function can be called outside of React components.
 *
 * Falls back to window.$r if cache is not available.
 */
export const getRecoveryStorage = () => {
  // Try to get from SWR cache first
  let data = getCachedData<RecoverResponse>("ip")

  // Fall back to window.$r if available (set by useIP onSuccess)
  if (!data && typeof window !== "undefined" && window.$r) {
    data = window.$r
  }

  return {
    data,
    bot: data?.bot,
    ip: data?.ip,
    isp: data?.isp,
    loc: data?.loc,
    geo: data?.geo,
    proxy: data?.proxy,
    ua: data?.ua,
    weather: data?.w,
  }
}
